<!-- static content data from lang: my_request -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
       <template v-if="errored"> <Notfound/>
         <!-- {{this.$router.push({path: '*'})}} -->
       </template>
    <template v-else>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.addHeaderTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <div class="request-detail">
              <div class="row">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                  <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.siteName}}:</h3>
                    <span class="d-block form-control-label font-weight-500"> {{(data.SiteName!= '' ? data.SiteName : lang.label.noData)}}</span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.visitorName}}:</h3>
                    <span class="d-block form-control-label font-weight-500">{{(data.VisitorName!= '' ? data.VisitorName : lang.label.noData)}}</span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.accessDate}}:</h3>
                    <span class="d-block form-control-label font-weight-500"> {{( data.AccessRequestDateFrom != '' ? formatFromdate(data.AccessRequestDateFrom) : lang.label.noData )}} &nbsp;-  &nbsp;{{( data.AccessRequestDateTo != '' ? formatTodate(data.AccessRequestDateTo) : lang.label.noData )}}</span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.hostUserName}}:</h3>
                    <span class="d-block form-control-label font-weight-500">{{(data.HostUser !='' ? data.HostUser : lang.label.noData)}}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.visitorRemarks}}:</h3>
                    <span class="d-block form-control-label font-weight-500" >{{(data.VisitorRemarks !='' ? data.VisitorRemarks :lang.label.noData)}}</span>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                     <div v-if="questionAnswers != ''">
                    <h3 class="d-block form-control-label font-weight-700" >{{lang.label.questions}}</h3>
                    <div class="form-group question-list"  v-for="(que, index) in questionAnswers" :key="index">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-control-label">
                                <badge type="default" class="que-count">{{index + 1}}</badge>
                                <span v-html="que.CompanyQuestionnaireQuestionName"></span>
                                <span class="d-block mt-1">Answer: <strong>{{que.QuestionAnswerBoolean}}</strong></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                        <!-- <div v-else>
                              <div class="row">
                            <div class="col-md-12">
                              <div class="form-control-label">
                                <h3 class="d-block form-control-label font-weight-700" >{{lang.label.questions}}
                                   <badge type="default" class="que-count">0</badge>
                                  </h3>
                                     <badge type="default" class="que-count">No question</badge>

                                </div>
                            </div>
                          </div>
                        </div> -->

                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.siteRemarks}}:</h3>
                    <span class="d-block form-control-label font-weight-500">{{(data.SiteRemarks !='' ? data.SiteRemarks : lang.label.noData)}}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.status}}:</h3>
                    <span class="d-block form-control-label font-weight-500">{{(data.Status !='' ? data.Status : lang.label.noData)}}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    </template>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import jsondata from "assets/json/data.json";
import Notfound from "@/views/GeneralViews/NotFoundPage.vue";
var moment = require('moment');
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    RouteBreadCrumb,
    Notfound
  },
  data() {
    return {
        ID :this.$route.params.id,
      lang: this.$lang.my_request,
      data: {},
      questionAnswers:[],
      loading:true,
      errored:false,
      model: {
        company: "",
        site: "",
        userName: "",
        password: "",
        name: "",
        emailAddress: ""
      },
      selects: {
        simple: "Select"
      },
      company: [
        { label: "Company Name 1", value: "Company Name 1" },
        { label: "Company Name 2", value: "Company Name 2" },
        { label: "Company Name 3", value: "Company Name 3" },
        { label: "Company Name 4", value: "Company Name 4" }
      ],
      site: [
        { label: "Site Name 1", value: "Site Name 1" },
        { label: "Site Name 2", value: "Site Name 2" },
        { label: "Site Name 3", value: "Site Name 3" },
        { label: "Site Name 4", value: "Site Name 4" }
      ],
      selected: [],
      roles: [
        { text: "Administrator", value: "Administrator" },
        { text: "Company Admin", value: "Company Admin" },
        { text: "Approve Access", value: "Approve Access" },
        { text: "Report Access", value: "Report Access" },
        {
          text: "Visitor Questionnaires Access",
          value: "Visitor Questionnaires Access"
        },
        { text: "Visitor Admin Access", value: "Visitor Admin Access" }
      ]
    };
  },
  mounted(){
    this.myRequestDetails();
  },
  methods: {
    onSubmit() {
      this.$router.push({ path: "list" });
    },
    myRequestDetails(){
      let self = this;
      let id = this.ID ;
     this.$store.dispatch('viewVisitorForms',id)
                   .then(response => {
                     this.data = response.data;
                      this.questionAnswers = response.data.Answers;
                      if(response.data.message){
                          if(response.status == 404){
                              this.errored = true;
                          }else{
                              if(typeof response.data.message != 'object'){
                                  this.alertMessages.push(response.data.message);
                              }else{
                                  let array = new Array();
                                  for (let key of Object.keys(response.data.message)) {
                                      let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                      array.push(obj)
                                  }
                                  this.alertMessages.push(array.join(', '));
                                  setTimeout(function () {
                                      self.alertMessages = [];
                                  },5000)
                              }
                          }
                          this.loading = false;
                      }
                    }).catch(error => {
                    }).finally(() => this.loading = false)
    },
    formatFromdate(date)
    {
        return moment(date).format('DD/MM/YYYY HH:mm');
     },
     formatTodate(date)
    {
        return moment(date).format('DD/MM/YYYY HH:mm');
     }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
